module.exports = __webpack_public_path__ + "img/poster6.f0a44192.jpg";